import { render } from "./ExpandableTextbox.vue?vue&type=template&id=3c8063d0&scoped=true&ts=true"
import script from "./ExpandableTextbox.vue?vue&type=script&lang=ts"
export * from "./ExpandableTextbox.vue?vue&type=script&lang=ts"

import "./ExpandableTextbox.vue?vue&type=style&index=0&id=3c8063d0&lang=scss&scoped=true"

import exportComponent from "/buddy/openbanking/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8063d0"]])

export default __exports__